import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Constants} from '../../../../../constants';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../../globals';
import {OrganizationConfigurationComponent} from '../../organization-configuration.component';

@Component({
    selector: 'app-organization-configuration-dialog',
    templateUrl: './organization-configuration-dialog.component.html',
    styleUrls: ['./organization-configuration-dialog.component.scss']
})
export class OrganizationConfigurationDialogComponent implements OnInit {

    @ViewChild(OrganizationConfigurationComponent, { static: false }) childComponent: OrganizationConfigurationComponent;
    isDialogMode: boolean = false;
    isViewOnly: boolean = false;
    enumOrganizationTypeId: string = Constants.emptyGuid;
    organizationId: string = Constants.emptyGuid;
    isLoading: boolean = false;
    showOrganizationTypeSelection: boolean = true;
    TDOCID: string;

    constructor(    @Inject(MAT_DIALOG_DATA) public data: any,
                    private dialogRef: MatDialogRef<OrganizationConfigurationDialogComponent>,
                    private snackBar: MatSnackBar,
                    private globals: Globals,
                    private dialog: MatDialog) { }

    ngOnInit(): void {

        if (this.data && this.data.organizationId) {
            this.organizationId = this.data.organizationId;
        }

        if (this.data && this.data.isDialogMode) {
            this.isDialogMode = this.data.isDialogMode;
        }

        if (this.data && this.data.enumOrganizationTypeId) {
            this.enumOrganizationTypeId = this.data.enumOrganizationTypeId;
        }

        if (this.data && this.data.isViewOnly) {
            this.isViewOnly = this.data.isViewOnly;
        }

        if (this.data && this.data.TDOCID) {
          this.isViewOnly = this.data.TDOCID;
        }


        if (this.data && this.data.showOrganizationTypeSelection === undefined) {
            this.showOrganizationTypeSelection = true;
        }
        else {
            this.showOrganizationTypeSelection = this.data.showOrganizationTypeSelection;
        }
    }

    // close() {
    // // from here save organization info
    //     this.childComponent.onSave();
    //     setTimeout(() => {
    //         this.dialogRef.close(this.organizationId);
    //     }, 2000); // Wait for 2 seconds

    // }

    close() {
        if (this.childComponent.isSaving) {
            console.warn('Save operation is still in progress. Please wait.');
            return;
        }
    
        this.childComponent.onSave();
    
        // Use a subscription to check when saving is complete
        const saveInterval = setInterval(() => {
            if (!this.childComponent.isSaving) {
                clearInterval(saveInterval);
                this.dialogRef.close(this.organizationId);
            }
        }, 500); // Check every 500ms
    }
    

    GetNewOrganizationID(newOrganizationID: string) {
        this.organizationId = newOrganizationID;
    }
}
